import withWidth from '@material-ui/core/withWidth';
import Tooltip from '@material-ui/core/Tooltip';
import React from 'react';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import { globalStyles as styles } from './style/gstheme';
import PropTypes from 'prop-types';

class PrimaryButton extends React.Component {

  render() {

    const { classes, onClick, endIcon, startIcon, title, disabled, important, width, raised } = this.props;

    return (

      title ?
        <Tooltip title={title}>
          <span>
            <Button
              data-test={this.props.dataTest}
              variant="contained"
              color="secondary"
              style={{ ...(important) && { color: 'white', backgroundColor: '#DD2C00' } }}
              disabled={disabled}
              onClick={onClick}
              endIcon={endIcon}
              startIcon={startIcon}
              className={classes.button}
              classes={{ ...(width === "xs" && endIcon) && { endIcon: classes.smallButtonIcon } }}
            >
              {(width !== "xs" || !endIcon) && this.props.children}
            </Button>
          </span>
        </Tooltip>
        :
        <Button
          data-test={this.props.dataTest}
          variant="contained"
          color="secondary"
          style={{
             ...(important) && { color: 'white', backgroundColor: '#DD2C00' },
             ...(raised) && { zIndex: 40 }
          }}
          disabled={disabled}
          onClick={onClick}
          endIcon={endIcon}
          startIcon={startIcon}
          className={classes.button}
          classes={{ ...(width === "xs" && endIcon) && { endIcon: classes.smallButtonIcon } }}
          >
          {(width !== "xs" || !endIcon) && this.props.children}
        </Button>
    );
  }
}

PrimaryButton.defaultProps = {
  disabled: false,
  important: false,
  raised: false,
  dataTest: "primary-action"
};

PrimaryButton.propTypes = {
  dataTest: PropTypes.string,
  raised: PropTypes.bool,
  width: PropTypes.string,
  children: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  title: PropTypes.string,
  important: PropTypes.bool,
  endIcon: PropTypes.object,
  startIcon: PropTypes.object,
  classes: PropTypes.object
};

export default withWidth()(withStyles(styles)(PrimaryButton));